<template>
  <div v-if="$store.state.doctor.userData" class="px-3 mt-2 bg-white text-center" style="min-height: calc(100vh - 75px)">
    <h3 class="text-premier-blue pt-4 mb-4">
      Masukkan kode OTP yang telah dikirim ke <br>
      <span v-if="$store.state.doctor.userData" class="font-rubik-medium">
        {{ $store.state.doctor.userData.Email }} dan
        {{ $store.state.doctor.userData.Phone.substr(0, 5) }}xxxxxx{{ $store.state.doctor.userData.Phone.substr($store.state.doctor.userData.Phone.length - 3) }}
      </span>
    </h3>
    <div class="otp-input-container">
      <client-only>
        <v-otp-input
          ref="otpInput"
          input-classes="otp-input"
          separator="-"
          :num-inputs="4"
          :should-auto-focus="true"
          :is-input-num="true"
          @on-change="handleOnChange"
          @on-complete="handleOnComplete"
        />
      </client-only>
    </div>
    <p v-if="messageError !== ''" class="text-danger">
      {{ messageError }}
    </p>
    <b-button size="lg" variant="success-2" class="px-6 border-r25px" :disabled="messageError.length > 0 || isLoading || dataOtp.length < 4" @click="handleSubmit">
      LANJUTKAN
      <b-spinner v-if="isLoading" small label="Small Spinner" variant="light" class="mb-1" />
    </b-button>
    <div v-if="$store.state.doctor.userData.BannedTime" class="text-danger mt-4">
      Anda telah melampaui limit permintaan pengiriman ulang kode.
    </div>
    <div class="w-100">
      <p v-if="totalTime > 0" class="text-danger mt-4">
        Kirim ulang kode
        <span>{{ minutes }}</span>:<span>{{ seconds }}</span>
      </p>
      <p v-else class="text-premier-blue font-rubik-medium cursor-pointer underline mt-4" @click="resendOTP">
        Kirim Ulang
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InputOtp',
  data: () => ({
    dataOtp: '',
    messageError: '',
    isLoading: false,
    timer: null,
    totalTime: 120,
    delayTime: 120,
    expired_in: 0
  }),
  computed: {
    isStartTime () {
      return this.startTimer()
    },
    minutes () {
      const minutes = Math.floor(this.totalTime / 60)
      return this.padTime(minutes)
    },
    seconds () {
      const seconds = this.totalTime - (this.minutes * 60)
      return this.padTime(seconds)
    }
  },
  created () {
    this.checkAvailableResend()
  },
  methods: {
    handleSubmit () {
      this.isLoading = true

      const payload = {
        Code: this.dataOtp
      }
      this.$store.dispatch('doctor/verification', payload)
        .then((res) => {
          if (res && res.Status === 'Error') {
            this.isLoading = false
            this.messageError = 'Kode verifikasi tidak sah'
            return
          }
          if (res && res.Data) {
            this.isLoading = false
            if (process.client) { window.scrollTo(0, 0) }
            return this.handleNext()
          }
        })
        .catch((err) => {
          this.isLoading = false
          throw new Error(err)
        })
    },
    padTime (time) {
      return (time < 10 ? '0' : '') + time
    },
    handleOnComplete () {
      this.handleSubmit()
    },
    handleOnChange (value) {
      this.dataOtp = value
    },
    resendOTP () {
      this.requestOtp()

      this.totalTime = this.delayTime

      return this.startTimer()
    },
    requestOtp () {
      this.$store.dispatch('doctor/resendOtpV4')
        .then((res) => {
          if (res && res.Data) {
            this.messageError = res.Message
            return this.checkAvailableResend()
          }
        })
        .catch((err) => {
          throw new Error(err)
        })
    },
    checkAvailableResend () {
      if (!this.$store.state.doctor.userData) { return this.goToInitial() }

      const epoch = this.$store.state.doctor.userData.BannedTime
      const timesNow = this.$store.state.doctor.userData.Timestamp
      const dateNow = new Date(timesNow * 1000)
      const dateBanned = new Date(epoch * 1000)

      const bannedTime = Math.abs((dateBanned - dateNow) / 1000) // get diference time in seconds

      if (bannedTime > 0) {
        this.totalTime = bannedTime
      }

      return this.startTimer()
    },
    resetTimer () {
      clearTimeout(this.timer)
      this.timer = null
    },
    startTimer () {
      this.resetTimer()
      this.countDownTimer()
    },
    countDownTimer () {
      if (this.totalTime > 0) {
        this.timer = setTimeout(() => {
          this.totalTime -= 1
          this.countDownTimer()
        }, 1000)
      } else {
        this.totalTime = 0
        this.resetTimer()
      }
    },
    handleNext () {
      this.$store.commit('doctor/SET_STEP', 'confirmation')
      localStorage.setItem('step', 'confirmation')
    },
    goToInitial () {
      this.$store.commit('doctor/SET_STEP', 'initial')
      localStorage.setItem('step', 'initial')
    }
  }
}
</script>

<style lang="scss">
  .underline:hover {
    text-decoration: underline;
  }
</style>
